import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { verifyToken } from '../utils/token';

const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={props => (
      verifyToken() ?
        <Component {...props} />
        : <Redirect to="/signin" />
    )} />
  );
};

export default PrivateRoute;